import { deepMerge } from "./../_shared/deep-merge.js";
import {
  HEADING_FONT_SIZES,
  PARAGRAPH_FONT_SIZE,
  ACTION_COLOR_DEFAULT,
  BG_COLOR_DEFAULT,
  TEXT_COLOR_DEFAULT
} from "./theme-constants.js";
const resolveTheme = ({
  theme = {},
  environment,
  isMobile = false
}) => {
  const { useWixStyles, useNativeStyles, ...userTheme } = theme;
  const isWix = useWixStyles || environment === "businessManager" || environment === "wixel";
  const envPreset = useNativeStyles ? nativePreset : isWix ? wixPreset : liveSitePreset;
  const baseDefaults = isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop;
  return deepMerge(
    {},
    baseDefaults,
    envPreset,
    userTheme,
    isWix ? wixPriorityOverrides : {}
  );
};
const wixPreset = {
  palette: {
    actionColor: ACTION_COLOR_DEFAULT,
    bgColor: BG_COLOR_DEFAULT,
    textColor: TEXT_COLOR_DEFAULT
  },
  paletteConfig: {
    focusActionColor: ACTION_COLOR_DEFAULT,
    settingsActionColor: ACTION_COLOR_DEFAULT
  },
  settingsStyles: {
    dividers: {
      color: "#DFE5EB",
      height: "12px"
    },
    icons: {
      color: "#333853"
    },
    text: {
      color: "#333853",
      fontFamily: "Madefor"
    },
    whitebox: {
      borderRadius: "8px",
      boxShadow: "0 8px 8px 0 rgba(22, 45, 61, 0.12), 0 3px 24px 0 rgba(22, 45, 61, 0.18)"
    }
  }
};
const wixPriorityOverrides = {
  customStyles: {
    editor: {
      addPluginButton: {
        plusIconColor: ACTION_COLOR_DEFAULT
      }
    }
  }
};
const liveSitePreset = {
  palette: {},
  paletteConfig: {
    settingsActionColor: "#000000"
  },
  settingsStyles: {
    dividers: {
      color: "#ededed",
      height: "12px"
    },
    icons: {
      color: "#000000"
    },
    text: {
      color: "#000000",
      fontFamily: "HelveticaNeue,Helvetica,Arial"
    },
    whitebox: {
      borderRadius: "0px",
      boxShadow: "0 8px 8px 0 rgba(22, 45, 61, 0.12), 0 3px 24px 0 rgba(22, 45, 61, 0.18)"
    }
  }
};
const nativePreset = {
  nativeStyle: {
    text: {
      fontFamily: "Madefor",
      color: "#20303C"
    },
    primaryText: {
      fontWeight: 700
    },
    bgColor: {
      backgroundColor: "#F8F9FA"
    },
    secondary: {
      backgroundColor: "#E8ECF0"
    },
    whitebox: {
      borderRadius: "8px"
    },
    coverImage: {
      height: "70px",
      width: "70px",
      margin: "8px",
      border: "1px solid rgba(110, 120, 129, 0.1)"
    }
  }
};
const defaultCustomStyle = {
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: "1.5"
};
const defaultPalette = {
  bgColor: BG_COLOR_DEFAULT,
  textColor: TEXT_COLOR_DEFAULT
};
const THEME_DEFAULTS = {
  desktop: {
    customStyles: {
      p: {
        ...defaultCustomStyle,
        fontSize: PARAGRAPH_FONT_SIZE
      },
      h1: {
        ...defaultCustomStyle,
        fontSize: HEADING_FONT_SIZES.h1
      },
      h2: {
        ...defaultCustomStyle,
        fontSize: HEADING_FONT_SIZES.h2
      },
      h3: {
        ...defaultCustomStyle,
        fontSize: HEADING_FONT_SIZES.h3
      },
      h4: {
        ...defaultCustomStyle,
        fontSize: HEADING_FONT_SIZES.h4
      },
      h5: {
        ...defaultCustomStyle,
        fontSize: HEADING_FONT_SIZES.h5
      },
      h6: {
        ...defaultCustomStyle,
        fontSize: HEADING_FONT_SIZES.h6
      },
      quote: {
        lineHeight: "1.5",
        fontSize: "18px"
      },
      codeBlock: {
        lineHeight: "1.5"
      }
    },
    palette: defaultPalette
  },
  mobile: {
    customStyles: {
      p: {
        ...defaultCustomStyle,
        fontSize: "14px"
      },
      h1: {
        ...defaultCustomStyle,
        fontSize: "32px"
      },
      h2: {
        ...defaultCustomStyle,
        fontSize: "24px"
      },
      h3: {
        ...defaultCustomStyle,
        fontSize: "20px"
      },
      h4: {
        ...defaultCustomStyle,
        fontSize: "20px"
      },
      h5: {
        ...defaultCustomStyle,
        fontSize: "16px"
      },
      h6: {
        ...defaultCustomStyle,
        fontSize: "14px"
      },
      quote: {
        lineHeight: "1.5",
        fontSize: "18px"
      },
      codeBlock: {
        lineHeight: "1.5"
      }
    },
    palette: defaultPalette
  }
};
export {
  resolveTheme
};
//# sourceMappingURL=resolve-theme.js.map
